(function () {
  if (window.__ozDeliveryInfoBound) return;
  window.__ozDeliveryInfoBound = true;

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function qsa(root, sel) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    options = options || {};
    timeoutMs = timeoutMs || 5000;

    if (typeof AbortController === "undefined") {
      return fetch(url, options);
    }

    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, timeoutMs);

    var finalOptions = {};
    for (var k in options) {
      if (Object.prototype.hasOwnProperty.call(options, k)) {
        finalOptions[k] = options[k];
      }
    }
    finalOptions.signal = controller.signal;

    return fetch(url, finalOptions).then(
      function (res) {
        clearTimeout(timer);
        return res;
      },
      function (err) {
        clearTimeout(timer);
        throw err;
      },
    );
  }

  function DeliveryInfoManager(root) {
    if (!root || root.dataset.deliveryInfoBound === "1") return;

    root.dataset.deliveryInfoBound = "1";
    this.root = root;

    this.trigger = qs(root, "#change-address-trigger");
    this.modal = qs(root, "#zip-modal");
    this.zipInput = qs(root, "#zip-input");
    this.zipSubmit = qs(root, "#zip-submit");
    this.zipCancel = qs(root, "#zip-cancel");
    this.zipCancelSecondary = qs(root, "#zip-cancel-secondary");
    this.errorEl = qs(root, "#zip-error");
    this.cityEl = qs(root, "#delivery-city");
    this.spinner = qs(root, "#zip-loading");
    this.modalOverlay = qs(root, ".delivery-info__modal-overlay");
    this.defaultCity = (root.getAttribute("data-default-city") || "").trim();

    this.isLoading = false;
    this.init();
  }

  DeliveryInfoManager.prototype.init = function () {
    if (
      !this.trigger ||
      !this.modal ||
      !this.zipInput ||
      !this.zipSubmit ||
      !this.cityEl
    ) {
      return;
    }

    this.bindEvents();
    this.loadCityFromIP();
  };

  DeliveryInfoManager.prototype.bindEvents = function () {
    var self = this;

    this.trigger.addEventListener("click", function () {
      self.openModal();
    });

    if (this.zipCancel) {
      this.zipCancel.addEventListener("click", function () {
        self.closeModal();
      });
    }

    if (this.zipCancelSecondary) {
      this.zipCancelSecondary.addEventListener("click", function () {
        self.closeModal();
      });
    }

    if (this.modalOverlay) {
      this.modalOverlay.addEventListener("click", function () {
        self.closeModal();
      });
    }

    this.zipSubmit.addEventListener("click", function () {
      self.handleZipSubmit();
    });

    this.zipInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        self.handleZipSubmit();
      }

      if (e.key === "Escape") {
        self.closeModal();
      }
    });
  };

  DeliveryInfoManager.prototype.loadCityFromIP = async function () {
    try {
      var response = await fetchWithTimeout(
        "https://ipapi.co/json/",
        { method: "GET" },
        5000,
      );

      if (!response.ok) throw new Error("IP API returned non-200");

      var data = await response.json();
      if (!data || !data.city) throw new Error("No city in response");

      var region = data.region_code || data.region || "";
      var cityDisplay = region ? data.city + ", " + region : data.city;

      this.cityEl.textContent = cityDisplay;
    } catch (error) {
      // keep Liquid default city on failure
      if (this.defaultCity && !(this.cityEl.textContent || "").trim()) {
        this.cityEl.textContent = this.defaultCity;
      }

      try {
        console.warn(
          "[DeliveryInfo] IP geolocation failed:",
          error && error.message ? error.message : error,
        );
      } catch (e) {}
    }
  };

  DeliveryInfoManager.prototype.fetchCityByZip = async function (zip) {
    if (!zip || zip.length < 5) {
      throw new Error("Please enter a valid ZIP code.");
    }

    var encoded = encodeURIComponent(String(zip).trim());

    var response = await fetchWithTimeout(
      "https://api.zippopotam.us/us/" + encoded,
      { method: "GET" },
      5000,
    );

    if (!response.ok) {
      throw new Error("Invalid ZIP code. Please check and try again.");
    }

    var data = await response.json();

    if (!data.places || !data.places.length) {
      throw new Error("No place found for this ZIP code.");
    }

    var place = data.places[0];
    var state = place["state abbreviation"] || "";
    return state ? place["place name"] + ", " + state : place["place name"];
  };

  DeliveryInfoManager.prototype.setError = function (message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  };

  DeliveryInfoManager.prototype.clearError = function () {
    if (!this.errorEl) return;
    this.errorEl.textContent = "";
    this.errorEl.hidden = true;
  };

  DeliveryInfoManager.prototype.setLoading = function (isLoading) {
    this.isLoading = !!isLoading;

    if (this.spinner) this.spinner.hidden = !this.isLoading;
    if (this.zipSubmit) this.zipSubmit.disabled = this.isLoading;
    if (this.zipInput) this.zipInput.disabled = this.isLoading;
  };

  DeliveryInfoManager.prototype.openModal = function () {
    this.modal.hidden = false;
    this.clearError();
    this.zipInput.value = "";

    var self = this;
    requestAnimationFrame(function () {
      setTimeout(function () {
        if (self.zipInput) self.zipInput.focus();
      }, 60);
    });
  };

  DeliveryInfoManager.prototype.closeModal = function () {
    this.modal.hidden = true;
    this.clearError();
    this.zipInput.value = "";
  };

  DeliveryInfoManager.prototype.handleZipSubmit = async function () {
    if (this.isLoading) return;

    var zip = (this.zipInput.value || "").trim();

    if (!zip) {
      this.setError("Please enter a ZIP code.");
      return;
    }

    this.setLoading(true);
    this.clearError();

    try {
      var city = await this.fetchCityByZip(zip);
      this.cityEl.textContent = city;
      this.closeModal();
    } catch (error) {
      this.setError(
        (error && error.message) ||
          "Could not find this ZIP code. Please try again.",
      );
    } finally {
      this.setLoading(false);
    }
  };

  function initDeliveryInfo(scope) {
    var roots = [];

    if (scope && scope.nodeType === 1 && scope.matches(".delivery-info")) {
      roots = [scope];
    } else {
      roots = qsa(scope || document, ".delivery-info");
    }

    for (var i = 0; i < roots.length; i++) {
      new DeliveryInfoManager(roots[i]);
    }
  }

  function boot() {
    initDeliveryInfo(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.addEventListener("pageshow", boot);

  try {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added || !added.length) continue;

        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;

          if (
            (node.matches && node.matches(".delivery-info")) ||
            (node.querySelector && node.querySelector(".delivery-info"))
          ) {
            initDeliveryInfo(node);
          }
        }
      }
    });

    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
